import { render } from "./DefaultLabel.vue?vue&type=template&id=9f36b244&ts=true"
import script from "./DefaultLabel.vue?vue&type=script&lang=ts"
export * from "./DefaultLabel.vue?vue&type=script&lang=ts"

import "./DefaultLabel.vue?vue&type=style&index=0&id=9f36b244&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__